import { EDealType } from 'shared/types/dealType';
import { FOfferType } from 'shared/utils/category';

import { IAppState } from '../../common/state';
import { getDealType } from '../getDealType';
import { getOfferType } from '../getOfferType';

export function selectIsMixedListing(state: IAppState) {
  const dealType = getDealType(state);
  const offerType = getOfferType(state);

  return offerType === FOfferType.Flat && dealType === EDealType.Sale;
}
